export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-4">
            Temizlik ihtiyacınız için Day Temizlik Adana'dan hızlıca iletişime geçin
          </h2>
          <p className="text-sm md:text-base text-white mb-8 max-w-2xl mx-auto">
            Daire, apartman, site, ofis ve daha birçok alan için profesyonel temizlik çözümlerimizden yararlanın. Sarıçam ve Adana geneline hızlı hizmet.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="tel:05539591940"
              className="inline-flex items-center justify-center gap-2 bg-background-50 text-primary-500 px-6 py-3.5 rounded-md text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
              Hemen ara
            </a>
            <a
              href="https://wa.me/905539591940"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-accent-500 text-background-50 px-6 py-3.5 rounded-md text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
              WhatsApp ile yaz
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}